var classes = {"root":"GQOKa","carouselControlSizeSmall":"iFBiK","carouselControlSizeLarge":"QyB52","carouselControlVariantIrregular":"ad-WL","carouselControlStateDisabled":"_7f0BS"};

export { classes as default };
